export default __webpack_public_path__ + "static/media/me_quran_volt_newmet.0df26bab.ttf";